import { RoamRoute } from "@/commons/interface/building/roam-route";
import { bimAxios } from "@/config/axios";
import { AxiosResponse } from "axios";

export function findRoamRoutes(projectUuid: string, modelUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/models/${modelUuid}/roam-routes`, {
        params: {
            ...params
        }
    })
}

export function createRoamRoutes(projectUuid: string, modelUuid: string, data: RoamRoute, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/models/${modelUuid}/roam-routes`, data, {
        params: {
            ...params
        }
    })
}

export function updateRoamRoutes(uuid: string, data: RoamRoute, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.put(`/roam-routes/${uuid}`, data, {
        params: {
            ...params
        }
    })
}

export function deleteRoamRoutes(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.delete(`/roam-routes/${uuid}`, {
        params: {
            ...params
        }
    })
}
